import immer from 'immer';
import { useState } from 'react';
export function useForm(defaultValues = {}) {
    const [values, setValues] = useState(defaultValues);
    const get = (name) => {
        if (name == null) {
            throw new Error('Undefined `name` prop found in component. Please, make sure every form component has a `name` field.');
        }
        return values[name];
    };
    const set = (value, name) => {
        if (name == null) {
            throw new Error('Undefined `name` prop found in component. Please, make sure every form component has a `name` field.');
        }
        setValues((state) => {
            return immer(state, (draft) => {
                draft[name] = value;
            });
        });
    };
    const reset = () => {
        setValues(defaultValues);
    };
    return { set, get, values, reset };
}
//# sourceMappingURL=use-form.js.map